import React from 'react'
import { BackgroundMaskCover } from 'tsparticles/Options/Classes/BackgroundMask/BackgroundMaskCover'
import Navbar from '../../components/navbar/index'

const Projects = () => {
  return (
    <div className='projects'>
      <Navbar />
      <div
        className='main'
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className='heading'>Page Under Construction...</div>
      </div>
    </div>
  )
}

export default Projects
